import {
    Container,
    Typography,
    Box,
    Stack,
    Grid,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import OrgMonthlyStatBarChart from "../../components/chart/OrgMonthlyStatBarChart";
import OrgStatDashboardData from "../../components/chart/OrgStatDashboardData";
import OrgSkillStatDashboardTable from "../../components/chart/OrgSkillStatDashboardTable";
import { getCurrentPeriodYear } from "../../helper/DatePeriodHelper";
import DatePeriodOption from "../../components/common/DatePeriodOption";

export default function TestOrgStatComponent() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);
    const [startYear, setStartYear] = React.useState(getCurrentPeriodYear());

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    let year = 2024;
    let orgId = 129;
    let startMonth = 9;

    // setValue(1234);

    let handleYearChange = (year) => {
        setStartYear(year);
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">TestOrgStatComponent</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <Box>
                    <pre>Start Year: {startYear} </pre>
                </Box>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={4}>
                        <DatePeriodOption value={startYear} onChange={handleYearChange} />
                    </Grid>

                    <Grid item xs={12}>
                        <OrgStatDashboardData orgId={orgId} year={startYear} startMonth={startMonth} />
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <OrgSkillStatDashboardTable orgId={orgId} year={startYear} startMonth={startMonth} />
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6} >
                        <Box sx={{ p: 0 }} >
                            <OrgMonthlyStatBarChart mode="participant" orgId={orgId} year={year} startMonth={startMonth} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <Box sx={{ p: 0 }} >
                            <OrgMonthlyStatBarChart mode="play_duration" orgId={orgId} year={year} startMonth={startMonth} />
                        </Box>
                    </Grid>
                </Grid>

            </Stack>
        </Container >
    )
}
